const inlineTags = juzRichTextExtender.inlineTags;

/**
 * Checks whether a tag can be nested within the current stack.
 * Only used for non-span tagNames — span is always allowed.
 *
 * @param {string[]} activeTags - Full stack of active tags (e.g. ['p', 'strong', 'em'])
 * @param {string} newTag - Tag to insert
 * @param {string[]} [innerTags=[]] - Tags already nested inside the selection (children)
 * @returns {boolean}
 */
export const canNestTag = (activeTags, newTag, innerTags = []) => {
    if (activeTags.length === 0 && innerTags.length === 0) return true;
    if (!inlineTags[newTag]) return false;

    for (const activeTag of activeTags) {
        if (activeTag === newTag && !inlineTags[newTag].canSelfNest) return false;
        if (activeTag !== newTag && inlineTags[activeTag] && !inlineTags[activeTag].canContain.includes(newTag)) return false;
    }

    if (activeTags.length > 0) {
        const parentTag = activeTags[activeTags.length - 1];
        if (!inlineTags[newTag].canNestIn.includes(parentTag)) return false;
    }

    if (inlineTags[newTag].canContain.length === 0 && innerTags.length > 0) return false;

    for (const innerTag of innerTags) {
        if (!inlineTags[newTag].canContain.includes(innerTag)) return false;
        if (inlineTags[innerTag] && !inlineTags[innerTag].canNestIn.includes(newTag)) return false;
    }

    return true;
};